import { render, staticRenderFns } from "./Disputed.vue?vue&type=template&id=276130ab&scoped=true&"
import script from "./Disputed.vue?vue&type=script&lang=js&"
export * from "./Disputed.vue?vue&type=script&lang=js&"
import style0 from "./Disputed.vue?vue&type=style&index=0&id=276130ab&lang=scss&scoped=true&"
import style1 from "./Disputed.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276130ab",
  null
  
)

export default component.exports